import { useQuery, gql } from '@apollo/client';
import useParamsRouter from '../../../hooks/useParamsRouter';

const GetCredentialIdFromGrouping = gql`
  query GetCredentialIdFromGrouping($groupingIdInt: Int!) {
    grouping(id: $groupingIdInt) {
      id
      programsOfStudy {
        id
        credential_type_id
      }
    }
  }
`;
export function useGetCredentialFromGroupingId() {
  const { groupingIdInt, formId } = useParamsRouter();
  const { loading, data } = useQuery(GetCredentialIdFromGrouping, {
    variables: { groupingIdInt },
  });
  if (loading) return { loading };
  return {
    loading,
    data,
    groupingIdInt,
    formId,
    credentialTypeId: data.grouping.programsOfStudy[0].credential_type_id,
  };
}
